import { VISITOR_LANGUAGE } from '@/features/visitors/api/types/visitor';
import { CreateVisitVisitorFormValues } from '../components/organisms/create-visit/schema/create-visit-validation-schema';

export const createEmptyVisitor = (): CreateVisitVisitorFormValues => ({
  localId: globalThis.crypto.randomUUID(),
  firstName: '',
  lastName: '',
  email: '',
  isHandicapped: false,
  isPregnant: false,
  hasPet: false,
  hasAccessToParking: false,
  discountTemplateId: null,
  language: VISITOR_LANGUAGE.ENGLISH,
  description: '',
});
